/**
 * Computes a simple moving average over a Highcharts-compatible `[timestamp, value][]` series.
 * The data is assumed to be evenly cadenced (1d or 1h); the window is index-based.
 *
 * Points with insufficient history (first `window - 1` positions) are omitted so the MA
 * line only starts once a full window of data is available.
 */
export function computeMovingAverage(data: [number, number][], window: number): [number, number][] {
  if (window <= 1 || data.length < window) {
    return [];
  }
  // Rolling sum: add the incoming point, subtract the one leaving the window — O(n) rather than
  // O(n·window). Float drift over the running sum is negligible at the metric's display precision.
  const result: [number, number][] = [];
  let sum = 0;
  for (let i = 0; i < data.length; i++) {
    sum += data[i][1];
    if (i >= window) {
      sum -= data[i - window][1];
    }
    if (i >= window - 1) {
      result.push([data[i][0], sum / window]);
    }
  }
  return result;
}
